import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
const app = firebase.initializeApp({
  apiKey: "AIzaSyCn9POIU_47PqUkkExZ3lSAEndmV_qB8q0",
  authDomain: "myapartment-68165.firebaseapp.com",
  databaseURL: "https://myapartment-68165.firebaseio.com",
  projectId: "myapartment-68165",
  storageBucket: "myapartment-68165.appspot.com",
  messagingSenderId: "368594759075",
  appId: "1:368594759075:web:037c35f7bd86d814e5fe16",
  measurementId: "G-5EVSCVXVVD",
});

export default app;
